<template>
  <div class="container-fluid">
    <div class="loading-state" v-if="loading">
      <ProgressSpinner fill="transparent" aria-label="Loading" />
    </div>
    <div class="row mb-5">
      <div class="col-12">
        <div class="card h-100 mt-2">
          <div class="card-header mb-0">
            <h5>
              {{ $t("content.amnreportprofit") }}
            </h5>
          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="col-lg-3">
                <label class="form-label ms-0">{{ $t("content.sdate") }}</label>
                <VueDatePicker v-model="start_date" :format="format" auto-apply :teleport="true"
                  :max-date="new Date().setHours(23, 59, 59)" :enable-time-picker="true" month-name-format="long"
                  :clearable="false" fluid :text-input="textInputOptions" />
              </div>
              <div class="col-lg-3">
                <label class="form-label ms-0">{{ $t("content.edate") }}</label>
                <VueDatePicker v-model="end_date" :format="format" auto-apply :teleport="true"
                  :max-date="new Date().setHours(23, 59, 59)" :enable-time-picker="true" month-name-format="long"
                  :clearable="false" fluid :text-input="textInputOptions" />
              </div>

              <div class="col-lg-3">
                <label class="form-label ms-0">{{ $t("content.names") }}</label>
                <div class="input-group">
                  <input v-model="cusName_search" type="text" class="form-control" aria-describedby="searchName"
                    readonly />
                  <button class="btn btn-primary" type="button" @click="openDialogCus">
                    <i class="material-icons material-symbols-outlined">search</i>
                  </button>
                  <button id="searchNameCus" class="btn btn-primary" type="button" data-bs-toggle="modal"
                    data-bs-target="#searchNameModal" v-show="false">
                  </button>
                </div>
              </div>

              <div class="col-lg-3">
                <label class="form-label ms-0">{{ $t("content.ticketno") }}</label>
                <material-input type="text" v-model="tk_search" />
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-3 d-flex justify-content-between align-items-center"></div>
              <div class="col-9 d-flex justify-content-end align-items-center">
                <div class="me-3">
                  <material-button id="cardSearch" color="primary" class="float-lg-start float-sm-end mb-3"
                    @click="loadRpInterestApi">
                    <i class="material-icons material-symbols-outlined">search</i>
                    {{ search }}
                  </material-button>
                </div>
                <div class="me-3">
                  <material-button id="cardSearch" color="danger" class="float-lg-start float-sm-end mb-3"
                    @click="cancelBtn">
                    <i class="material-icons material-symbols-outlined">close</i>
                    {{ cancel }}
                  </material-button>
                </div>
              </div>
            </div>
            <hr />
            <div class="d-flex justify-content-end align-items-center">
              <label class="form-label m-0 me-2">{{ $t("content.expfile") }} :</label>
              <material-button id="pdfBtn" color="info" variant="outline" class="float-lg-start float-sm-end mb-0 me-2"
                @click="pdfGen" :disabled="listinterest.length === 0">
                <i class="material-icons material-symbols-outlined">picture_as_pdf</i> pdf
              </material-button>
              <material-button id="excelBtn" color="info" variant="outline"
                cclass="float-lg-start float-sm-end mb-0 me-2" @click="XlsxGen" :disabled="listinterest.length === 0">
                <i class="material-icons material-symbols-outlined">table_rows</i> Excel
              </material-button>
            </div>
            <div class="row mt-3">
              <div class="table-responsive">
                <table class="table table-flush">
                  <thead class="thead-light">
                    <tr>
                      <th>#</th>
                      <th>{{ $t("content.amndatepayprofit") }}</th>
                      <th>{{ $t("content.amnpawndate") }}</th>
                      <th>{{ $t("content.amnreceiptno") }}</th>
                      <th>{{ $t("content.ticketno") }}</th>
                      <th>{{ $t("content.names") }}</th>
                      <th>{{ $t("content.amnpawnvalall") }}</th>
                      <th>{{ $t("content.amnprofitval") }}</th>
                      <th>{{ $t("content.amndiscount") }}</th>
                      <th>{{ $t("content.spedis") }}</th>
                      <th>{{ $t("content.amnexceptprofit") }}</th>
                      <th>{{ $t("content.amnrealprofit") }}</th>
                      <th>{{ $t("content.amndifference") }}</th>
                      <th>{{ $t("content.amnmaker") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in listinterest" :key="index">
                      <td class="text-sm font-weight-normal border-0">
                        {{ formatNumberString((currentPage - 1) * perPage + index + 1) }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ format_datetime(row.createDate) }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ format_datetime(row.pawnDate) }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ row.refNumber }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ row.tkRefNumber }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ row.name }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ formatNumberDecimalString(row.pawnValue) }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ formatNumberDecimalString(row.interestCalc) }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ formatNumberDecimalString(row.discount) }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ formatNumberDecimalString(row.calDiscount) }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ formatNumberDecimalString(row.waiveInterest) }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ formatNumberDecimalString(row.roundInterest) }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ formatNumberDecimalString(row.diffValue) }}
                      </td>
                      <td class="text-sm font-weight-normal">
                        {{ row.manager }}
                      </td>
                    </tr>
                    <tr v-if="listinterest.length === 0">
                      <td colspan="16" class="text-sm font-weight-normal">
                        <p style="text-align: center">No Record Found</p>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="group-sub-header">
                      <td class="text-lg font-weight-bold text-center" colspan="7">
                        <b>{{ $t("content.gtotal") }}</b>
                      </td>
                      <td class="text-lg font-weight-bold">
                        <b> {{ formatNumberDecimalString(tt_interestCalc) }}</b>
                      </td>
                      <td class="text-lg font-weight-bold">
                        <b>{{ formatNumberDecimalString(tt_discount) }}</b>
                      </td>
                      <td class="text-lg font-weight-bold">
                      </td>
                      <td class="text-lg font-weight-bold">
                        <b>{{ formatNumberDecimalString(tt_waiveInterest) }}</b>
                      </td>
                      <td class="text-lg font-weight-bold">
                        <b>{{ formatNumberDecimalString(tt_roundInterest) }}</b>
                      </td>
                      <td class="text-lg font-weight-bold">
                        <b>{{ formatNumberDecimalString(tt_diffValue) }}</b>
                      </td>
                      <td style="text-align: right">Total Rows : {{ totalRows_s }}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
            <pre></pre>
            <div style="display: flex; justify-content: flex-end">
              <ul v-show="listinterest.length > 0" class="pagination justify-content-end">
                <div class="project-container">
                  <div class="example-one">
                    <vue-awesome-paginate v-model="currentPage" :total-items="totalRows" :items-per-page="perPage"
                      @click="onClickHandler" />
                  </div>
                </div>
              </ul>
            </div>
          </div>
        </div>

        <!-- Search Customer Dialog -->
        <div id="searchNameModal" class="modal fade" tabindex="-1" aria-labelledby="searchNameModalLabel"
          aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{ $t("content.cnamelist") }}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" id="closeModal">
                  <i class="material-icons material-symbols-outlined">close</i>
                </button>
              </div>

              <div class="modal-body">
                <div class="preview-table">
                  <section class="panel">
                    <table class="table table-striped table-responsive">
                      <thead>
                        <tr>
                          <!-- <th style="width: 100px">{{ $t("content.ccode") }}</th> -->
                          <th>#</th>
                          <th>{{ $t("content.cnameth") }}</th>
                          <th>{{ $t("content.cnameen") }}</th>
                          <th>{{ $t("content.docno") }}</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="row-search">
                          <td></td>
                          <td>
                            <material-input v-model="nameThC" type="text" :label="t('content.cnameth')" />
                          </td>
                          <td>
                            <material-input v-model="nameEnC" type="text" :label="t('content.cnameen')" />
                          </td>
                          <td>
                            <material-input v-model="docNumberC" type="text" :label="t('content.docno')" />
                          </td>
                          <td>
                            <material-button color="primary" variant="contain" class="rounded-circle ms-1"
                              data-bs-toggle="tooltip" data-bs-placement="top" :title="btnSearch"
                              :disabled="nameThC.length < 2 && nameEnC.length < 2 && docNumberC.length < 5"
                              @click="loadCustomerAfListApi">
                              <i class="material-icons material-symbols-outlined">search</i>
                            </material-button>
                          </td>
                        </tr>
                        <tr v-for="(row, index) in customerlist" :key="index" @click="selectCusAf(row)">
                          <td>{{ formatNumberString((currentPageC - 1) * perPageC + index + 1) }}</td>
                          <td>{{ row.nameTh }}</td>
                          <td>{{ row.nameEn }}</td>
                          <td colspan="2">{{ row.docNumber }}</td>
                        </tr>
                        <tr v-if="customerlist.length === 0">
                          <td colspan="5" class="text-sm font-weight-normal">
                            <p style="text-align: center">No Record Found</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </section>
                </div>
              </div>

              <div class="modal-footer">
                <pre></pre>
                <div style="display: flex; justify-content: flex-end">
                  <ul v-show="customerlist.length > 0" class="pagination justify-content-end">
                    <div class="project-container">
                      <div class="example-one">
                        <vue-awesome-paginate v-model="currentPageC" :total-items="totalRowsC"
                          :items-per-page="perPageC" @click="onClickHandlerC" />
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import { inject, computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import ProgressSpinner from 'primevue/progressspinner';
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'


import axios from "axios";
import * as st from "@/config/setting.js";
import moment from 'moment'
import ExampleFive from "@/examples/ExampleOne";


import { useCustomerStore } from '@/stores/customer'
import { useReportInterestStore } from '@/stores/rpinterest'
import { useCashAccountStore } from '@/stores/cashaccount'
import { useShopStore } from '@/stores/shop'

const storecus = useCustomerStore()
const storerpi = useReportInterestStore()
const storeca = useCashAccountStore()
const storesh = useShopStore()


const { t } = useI18n();
const swal = inject("$swal");

const start_date = ref(new Date(new Date().setHours(0, 0, 0)));
const end_date = ref(new Date(new Date().setHours(23, 59, 59)));
const cusUid_search = ref('');
const cusName_search = ref('');
const tk_search = ref('');
const currentPage = ref(1);
const totalRows = ref(1);
const perPage = ref(30);
const totalRows_s = ref();
const currentPageC = ref(1);
const totalRowsC = ref(1);
const perPageC = ref(10);
const totalRows_sC = ref();
const nameThC = ref('')
const nameEnC = ref('')
const docNumberC = ref('')
const listinterest = ref([]);
const customerlist = ref([])
const shop_info = ref(null)
const tt_waiveInterest = ref(0);
const tt_roundInterest = ref(0);
const tt_total = ref(0);
const tt_diffValue = ref(0);
const tt_discount = ref(0);
const tt_interestCalc = ref(0);
const loading = ref(false);

const key = JSON.parse(localStorage.getItem("shop_seleted"));

const search = computed(() => t("buttons.sear"));
const cancel = computed(() => t("buttons.canc"));


const format = (date) => {
  return moment(String(date)).local().format('DD/MM/YYYY HH:mm');
}

const textInputOptions = {
  format: 'dd/MM/yyyy HH:mm'
};

const onClickHandler = (page) => {
  updatePagination()
};

const onClickHandlerC = (page) => {
  updatePaginationC()
};


function formatNumberString(num) {
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}


function formatNumberDecimalString(num) {
  if (num !== null && num !== undefined) {
    num = num.toFixed(2)
  } else {
    num = 0
    num = num.toFixed(2)
  }
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}


function format_datetime(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY HH:mm:ss')
  }
}


function cancelBtn() {
  start_date.value = new Date(new Date().setHours(0, 0, 0));
  end_date.value = new Date(new Date().setHours(23, 59, 59));
  cusUid_search.value = '';
  cusName_search.value = '';
  tk_search.value = '';
  currentPage.value = 1;
  totalRows_s.value = ''
  listinterest.value = []
  tt_waiveInterest.value = 0;
  tt_roundInterest.value = 0;
  tt_total.value = 0;
  tt_diffValue.value = 0;
  tt_discount.value = 0;
  tt_interestCalc.value = 0;
  loadRpInterestApi();
}

const loadRpInterestApi = async () => {
  if (cusUid_search.value !== '' || tk_search.value) {
    currentPage.value = 1
  }

  let sd = ''
  let ed = ''
  sd = moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss')
  ed = moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59')

  let data = "";
  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    groupUid: key.groupUid,
    shopUid: key.uid,
    fromDate: sd,
    toDate: ed,
    customerUid: cusUid_search.value,
    tkRefNumber: tk_search.value.trim(),
  };

  const payload = data;
  const response = await storerpi.rpInterestListFetch(payload);
  // console.log("RpInt : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listinterest.value = response.data.data.list;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
        tt_waiveInterest.value = response.data.data.ext.waiveInterest;
        tt_roundInterest.value = response.data.data.ext.roundInterest;
        tt_diffValue.value = response.data.data.ext.diffValue;
        tt_discount.value = response.data.data.ext.discount;
        tt_interestCalc.value = response.data.data.ext.interestCalc;
      }
    }
  }
}
loadRpInterestApi()

async function updatePagination() {
  listinterest.value = []
  let sd = ''
  let ed = ''
  sd = moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss')
  ed = moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59')

  let data = "";
  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    groupUid: key.groupUid,
    shopUid: key.uid,
    fromDate: sd,
    toDate: ed,
    customerUid: cusUid_search.value,
    tkRefNumber: tk_search.value.trim(),
  };

  const payload = data;
  const response = await storerpi.rpInterestListFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listinterest.value = response.data.data.list;
        totalRows.value = response.data.data.ext.total
        totalRows_s.value = formatNumberString(totalRows.value)
        tt_waiveInterest.value = response.data.data.ext.waiveInterest;
        tt_roundInterest.value = response.data.data.ext.roundInterest;
        tt_diffValue.value = response.data.data.ext.diffValue;
        tt_discount.value = response.data.data.ext.discount;
        tt_interestCalc.value = response.data.data.ext.interestCalc;
      }
    }
  }
}

async function openDialogCus() {
  nameThC.value = ''
  nameEnC.value = ''
  docNumberC.value = ''
  cusUid_search.value = ''
  cusName_search.value = ''
  customerlist.value = []
  document.getElementById("searchNameCus").click();
}

async function selectCusAf(item) {
  cusUid_search.value = item.uid
  cusName_search.value = item.nameTh
  document.getElementById("closeModal").click();
}

async function loadCustomerAfListApi() {
  currentPageC.value = 1
  let data = "";
  data = {
    index: currentPageC.value - 1,
    size: perPageC.value,
    nameEn: nameEnC.value,
    nameTh: nameThC.value,
    docNumber: docNumberC.value

  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storecus.searchCustomerFetch(payload);
  // console.log("loadCustomerListApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let listd = response.data.data.list;
        customerlist.value = listd;
        totalRowsC.value = response.data.data.ext.total
        totalRows_sC.value = formatNumberString(totalRowsC.value)
      }
    }
  }
}


async function updatePaginationC() {
  customerlist.value = []
  let data = "";
  data = {
    index: currentPageC.value - 1,
    size: perPageC.value,
    nameEn: nameEnC.value,
    nameTh: nameThC.value,
    docNumber: docNumberC.value

  };
  const payload = data;
  const response = await storecus.searchCustomerFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        customerlist.value = response.data.data.list;
        totalRowsC.value = response.data.data.ext.total
        totalRows_sC.value = formatNumberString(totalRowsC.value)
      }
    }
  }
}

async function getShopInfo() {
  shop_info.value = null
  let data = "";
  data = {
    uid: key.uid,
  };
  const payload = data;
  const response = await storesh.shopInfoFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        shop_info.value = response.data.data
        // console.log('shop_info : ' + JSON.stringify(shop_info.value));
      }
    }
  }
}


async function XlsxGen() {
  loading.value = true
  if (shop_info.value === null) {
    await getShopInfo()
  }

  let data = "";
  let sd = ''
  let ed = ''
  sd = moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss')
  ed = moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59')

  data = {
    page: {
      index: "0",
      size: "0", // size=0 all result
      sort: ""
    },
    filter: {
      groupUid: shop_info.value.groupUid,
      shopUid: shop_info.value.uid,
      fromDate: sd,
      toDate: ed,
      customerUid: cusUid_search.value,
      tkRefNumber: tk_search.value.trim(),
      shopName: shop_info.value.fullname,
    },
  };
  const keya = JSON.parse(localStorage.getItem("FR-SDK-nvtx-admin"));
  const accessToken = keya.accessToken;
  const response = await axios({
    method: 'POST',
    data: data,
    url: st.url_api + `/pawn-rpt-svc/interest/list/xlsx`,
    headers: { Authorization: `Bearer ${accessToken}` },
    responseType: 'arraybuffer',
  });
  loading.value = false
  if (response.headers.get("content-type") === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
    // console.log('XlsxGen : ' + JSON.stringify(response.headers.get("content-type")));
    let today = moment(new Date()).local().format('YYYYMMDD_HHmmss')
    let fileName = `rpInterest_${today}.xlsx`
    const url = URL.createObjectURL(new Blob([response.data], { type: "application/xlsx" }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
  } else {
    swal("โหลด EXCEL ไม่สำเร็จ", "", "error");
  }
}


async function pdfGen() {
  loading.value = true
  if (shop_info.value === null) {
    await getShopInfo()
  }
  let data = "";
  let sd = ''
  let ed = ''
  sd = moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss')
  ed = moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59')
  data = {
    page: {
      index: "0",
      size: "0", // size=0 all result
      sort: ""
    },
    filter: {
      groupUid: shop_info.value.groupUid,
      shopUid: shop_info.value.uid,
      fromDate: sd,
      toDate: ed,
      customerUid: cusUid_search.value,
      tkRefNumber: tk_search.value.trim(),
      shopName: shop_info.value.fullname,
    },
  };
  const keya = JSON.parse(localStorage.getItem("FR-SDK-nvtx-admin"));
  const accessToken = keya.accessToken;
  const response = await axios({
    method: 'POST',
    data: data,
    url: st.url_api + `/pawn-rpt-svc/interest/list/pdf`,
    headers: { Authorization: `Bearer ${accessToken}` },
    responseType: 'arraybuffer',
  });
  loading.value = false
  // console.log('pdfGen : ' + JSON.stringify(response.headers.get("content-type")));
  if (response.headers.get("content-type") === 'application/pdf') {

    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank').focus();
  } else {
    swal("โหลด PDF ไม่สำเร็จ", "", "error");
  }
}

</script>

<style lang="scss" scoped>
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
